import React from 'react';
import PropTypes from 'prop-types';

// const PaymentSummary = ({ totals, tax }) => (
  const PaymentSummary = ({ totals }) => (
  <div className="order-total bg-total bg-white p-0">
    <h5 className="mb-3">Payment Summary</h5>
    <table className="table table-responsive table-borderless">
      <tbody>
        {/* <tr>
          <td>
            Tax
            <a href="#" className="ms-3 link-default" data-bs-toggle="modal" data-bs-target="#order-tax">
              <i className="ti ti-edit"></i>
            </a>
          </td>
          <td className="text-gray-9 text-end">${tax.toFixed(2)}</td>
        </tr> */}
        <tr>
          <td>
            <span className="text-danger">Discount</span>
            <a href="#" className="ms-3 link-default" data-bs-toggle="modal" data-bs-target="#discount">
              <i className="ti ti-edit"></i>
            </a>
          </td>
          <td className="text-danger text-end">${totals.totalDiscount.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Sub Total</td>
          <td className="text-gray-9 text-end">${totals.subtotal.toFixed(2)}</td>
        </tr>
        <tr>
          <td className="fw-bold border-top border-dashed">Total Payable</td>
          <td className="text-gray-9 fw-bold text-end border-top border-dashed">${totals.total.toFixed(2)}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

PaymentSummary.propTypes = {
  totals: PropTypes.shape({
    subtotal: PropTypes.number.isRequired,
    totalDiscount: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  tax: PropTypes.number.isRequired,
};
export default PaymentSummary;
